export default {
  SET: (state, payload) => {
    if (Array.isArray(payload)) {
      payload.map(obj => {
        state[obj.key] = obj.value;
      });
    } else {
      state[payload.key] = payload.value;
    }
  },
  RESET: state => {  
    Object.keys(state).map( (key) => {

      if(key !== 'tcsoc') 
      switch(typeof state[key]) {
        case 'string':
          state[key] = '';
          break;
      }
    })
  },
};
